<template>
  <div>
    <v-row no-gutters>
      <v-img
        class="my-image"
        src="@/assets/ems_images/toronto1.webp"
        position="relative"
        fill-height
      >
        <!-- Position the text content absolutely within the v-img container -->
        <div
          class="text-content"
          style="position: absolute; top: 0; left: 0; padding: 16px"
        >
          <span
            :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
            class="font-weight-black black--text custom-font"
          >
            EXECUTIVE MAINTENANCE
          </span>
          <br />
          <span
            :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
            class="font-weight-black red--text custom-font"
          >
            SERVICES INC
          </span>
          <v-btn
            class="mb-5"
            outlined
            color="black"
            @click="$vuetify.goTo('#history')"
          >
            <v-icon>mdi-chevron-double-down</v-icon>
          </v-btn>
          <br />
          <span
            :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-1']"
            class="font-weight-light black--text"
          >
            A Division Of Werek Enterprises
          </span>
          <br />
          <!-- Button directly under the last span without the 'align-self-end' class -->
          <div style="text-align: center"></div>
        </div>
        <div
          v-if="!isMobile"
          style="position: absolute; top: 0; right: 0; padding: 16px"
        >
          <v-img
            class="ems-image"
            contain
            max-height="70%"
            src="@/assets/ems_images/ems.png"
          ></v-img>
        </div>
      </v-img>
    </v-row>
  </div>
</template>


<script>
export default {
  name: "home",
  data() {
    return {};
  },
  computed: {
    isMobile() {
      // Detect mobile devices based on window width
      return window.innerWidth <= 960; // You can set your own mobile breakpoint
    },
  },
};
</script>

<style>
.my-image {
  height: 100vh; /* Adjust as necessary, could be a percentage or viewport unit */
  max-height: 100%; /* Ensures the image doesn't exceed the container's height */
}
.ems-image {
  height: 8vh; /* Adjust as necessary, could be a percentage or viewport unit */
  max-height: 100%; /* Ensures the image doesn't exceed the container's height */
}
</style>